/**
 * The smallest and largest box a frame may be resized to, shared by every
 * surface that resizes frames (canvas nodes, focus and floating windows).
 */
import {
  getFrameDefaultSize,
  WIDGET_FRAME_TYPES,
  WIDGET_MIN_SIZE,
} from "@/lib/frame-defaults";

const FRAME_MIN_WIDTH = 240;
const FRAME_MIN_HEIGHT = 120;
const CONVERSATION_MIN_WIDTH = getFrameDefaultSize("note").w;

export const FRAME_MAX_HEIGHT = 2000;

export function frameMinWidth(frameType: string): number {
  return frameType === "conversation"
    ? CONVERSATION_MIN_WIDTH
    : WIDGET_FRAME_TYPES.has(frameType)
      ? WIDGET_MIN_SIZE.w
      : FRAME_MIN_WIDTH;
}

export function frameMinHeight(frameType: string): number {
  return WIDGET_FRAME_TYPES.has(frameType)
    ? WIDGET_MIN_SIZE.h
    : FRAME_MIN_HEIGHT;
}
